import { useRouter } from "next/compat/router";
import { pathTranslator, useToggle } from "../../../utils/language";
import { List } from "../../Listbox/Listbox";
import styles from "./LanguageToggle.module.scss";
import { Post } from "@aleksundshantu/schirdewan-standard-types/client";

export const LanguageToggle = ({
  post,
  addWrapper = false,
}: {
  post: Post;
  hide?: boolean;
  addWrapper?: boolean;
}) => {
  const router = useRouter();
  const { toggle, setToggle } = useToggle();
  const availableTranslations = pathTranslator(post);
  const showLanguageToggle = availableTranslations.length > 0;

  const onLanguagePick = (e: string) => {
    if (availableTranslations.length > 0) {
      document.cookie = `NEXT_LOCALE=${e}; path=/`;
      setToggle(e);
    }
  };

  const ListJSX = (
    <List
      selected={toggle}
      availableTranslations={availableTranslations}
      setSelected={onLanguagePick}
      items={
        router?.locales?.map((l) => {
          return { label: l, value: l };
        }) ?? []
      }
      disableDropdown={availableTranslations.length < 1 ? true : false}
      alwaysOpenUntil="navbar-breakpoint"
      closeOnSelection
    />
  );

  return (
    <>
      {showLanguageToggle &&
        (addWrapper ? (
          <div className={`language-wrapper ${styles["language-wrapper"]}`}>
            {ListJSX}
          </div>
        ) : (
          ListJSX
        ))}
    </>
  );
};
